<template>
	<div class="gestionar-propuestas-page">
		<!-- Modal inicial: Seleccionar propuesta -->
		<el-dialog
			title="Gestionar Propuestas"
			:visible.sync="modalInicial.visible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			width="500px"
			class="modal-inicial-propuesta"
		>
			<div v-if="loadingInicial" style="text-align: center; padding: 2rem;" v-loading="true" element-loading-text="Cargando...">
				<p style="font-size: 1.1rem; margin-top: 3rem;">Cargando...</p>
			</div>
			<div v-else>
				<p style="text-align: center; margin-bottom: 1rem; font-size: 1.1rem;">
					Seleccione una propuesta para gestionar:
				</p>
				<el-select
					v-model="propuestaSeleccionada"
					placeholder="Seleccione una propuesta"
					filterable
					style="width: 100%"
					:loading="loadingPropuestas"
					@change="cargarPropuestaSeleccionada"
				>
					<el-option
						v-for="prop in listaPropuestas"
						:key="prop.id"
						:label="`${prop.codigo} - ${prop.buque} (${prop.tipo})`"
						:value="prop.id"
					/>
				</el-select>
			</div>
		</el-dialog>

		<div class="propuesta-container" v-if="!modalInicial.visible && propuesta.id">
			<!-- Header de la propuesta -->
			<div class="propuesta-header">
				<div class="header-row">
					<div class="header-field">
						<label>BUQUE:</label>
						<el-input 
							v-model="propuesta.buqueNombre" 
							placeholder="Buque"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
					<div class="header-field">
						<label>{{ propuesta.tipo === 'PUENTE' ? 'CAPITAN:' : 'J.MAQUINAS:' }}</label>
						<el-input 
							v-model="propuesta.jMaquinas" 
							:placeholder="propuesta.tipo === 'PUENTE' ? 'Nombre del capitán' : 'Nombre del jefe de máquinas'"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
					<div class="header-field header-title">
						<h2>{{ propuesta.tipo === 'PUENTE' ? 'GESTIÓN PROPUESTA PUENTE' : 'GESTIÓN PROPUESTA MAQUINAS' }}</h2>
					</div>
					<div class="header-field">
						<label>FECHA:</label>
						<el-input 
							v-model="propuesta.fecha" 
							placeholder="Fecha"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
					<div class="header-field">
						<label>N° PROPUESTA PED.:</label>
						<el-input 
							v-model="propuesta.numeroPropuesta" 
							placeholder="Número de propuesta"
							size="small"
							:disabled="true"
							readonly
						/>
					</div>
				</div>
				<!-- Botones de acción -->
				<div class="propuesta-actions">
					<el-button type="primary" @click="guardarPropuesta">Guardar</el-button>
					<el-button @click="lanzarPropuesta">Terminar Revisión</el-button>
				</div>
			</div>

			<!-- Tabla de propuesta -->
			<div class="propuesta-table-container">
				<!-- Encabezados de columna -->
				<div class="table-header con-estado">
					<div class="col-posicion">POSICION</div>
					<div class="col-referencia">REFERENCIA</div>
					<div class="col-equipo">EQUIPO (MODELO, SN,_)</div>
					<div class="col-cantidad">Cantidad</div>
					<div class="col-cantidad-aprobada">Cant. Aprobada</div>
					<div class="col-unidad">Un. Medida</div>
					<div class="col-notas">Notas BARCO</div>
					<div class="col-anotaciones-tecnico">Anotaciones Dpt. Técnico</div>
					<div class="col-estado">ACCIÓN</div>
				</div>

				<!-- Grupos y líneas para MAQUINAS -->
				<template v-if="propuesta.tipo === 'MAQUINAS'">
					<div 
						v-for="grupo in gruposConLineas" 
						:key="grupo.id"
						class="grupo-section"
						:class="`grupo-${grupo.codigo.toLowerCase()}`"
					>
						<!-- Título del grupo -->
						<div 
							class="grupo-header" 
							@click="toggleGrupo(grupo.id)"
							:class="{'grupo-collapsed': !grupo.visible}"
						>
							<i :class="grupo.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							<span class="grupo-nombre">{{ grupo.nombre }} ({{ contarLineasGrupo(grupo) }})</span>
						</div>
						<template v-if="grupo.visible">
							<div 
								v-for="(linea, index) in grupo.lineasVisibles" 
								:key="`${grupo.id}-${index}`"
								class="table-row con-estado"
							>
								<div class="col-posicion">{{ linea.posicion }}</div>
								<div class="col-referencia">
									<el-input
										v-model="linea.referencia"
										placeholder="Referencia"
										size="small"
										:disabled="true"
										readonly
									/>
								</div>
								<div class="col-equipo">
									<el-tooltip
										:content="tooltipEquipoContenido"
										placement="top"
										:disabled="!tooltipEquipoActivo"
									>
										<span
											class="celda-equipo-tooltip"
											@mouseenter="evaluarTooltipEquipoOverflow($event, getEquipoConTalla(linea))"
											@mouseleave="ocultarTooltipEquipo"
										>
											<el-input
												:value="getEquipoConTalla(linea)"
												placeholder="Equipo (Modelo, SN,_)"
												size="small"
												:disabled="true"
												readonly
											/>
										</span>
									</el-tooltip>
								</div>
								<div class="col-cantidad">
									<el-input
										v-model="linea.cantidad"
										placeholder="0"
										size="small"
										type="text"
										:disabled="true"
										readonly
										@keypress="soloNumerosYComa"
										@input="filtrarCantidad(linea)"
									/>
									<div
										v-if="getTextoConversionInformativa(linea)"
										class="conversion-info"
									>
										{{ getTextoConversionInformativa(linea) }}
									</div>
								</div>
								<div class="col-cantidad-aprobada">
									<el-input
										v-model="linea.cantidadAprobada"
										placeholder="Opcional"
										size="small"
										type="text"
										:class="{ 'cantidad-aprobada-invalida': isCantidadAprobadaInvalida(linea) }"
										@keypress="soloNumerosYComa"
										@input="filtrarCantidadAprobada(linea)"
										@blur="validarCantidadAprobadaEnLinea(linea)"
									/>
								</div>
								<div class="col-unidad">
									<el-input
										v-model="linea.unidad"
										placeholder="Unidad"
										size="small"
										:disabled="true"
										readonly
									/>
								</div>
								<div class="col-notas">
									<el-input
										v-model="linea.notas"
										placeholder="Notas"
										size="small"
										:disabled="true"
										readonly
									/>
								</div>
								<div class="col-anotaciones-tecnico">
									<el-input
										v-model="linea.anotacionesTecnico"
										:class="{ 'anotacion-tecnico-invalida': isAnotacionTecnicoInvalida(linea) }"
										type="textarea"
										:rows="2"
										:placeholder="getPlaceholderAnotacionesTecnico(linea)"
										size="small"
										@input="actualizarLinea(grupo.id, index)"
									/>
								</div>
								<div class="col-estado">
									<el-radio-group v-model="linea.estado" size="small" @change="onEstadoInspeccionGroupChange(linea, $event, () => actualizarLinea(grupo.id, index))">
										<el-radio-button
											label="ACEPTADO"
											@mousedown.native="onEstadoInspeccionMousedown(linea, 'ACEPTADO', $event, () => actualizarLinea(grupo.id, index))"
											@click.native="onEstadoInspeccionClickSuprimir(linea, 'ACEPTADO', $event)"
											@mouseup.native="onEstadoInspeccionClickSuprimir(linea, 'ACEPTADO', $event)"
										>Aprobado</el-radio-button>
										<el-radio-button
											label="NO ACEPTADO"
											@mousedown.native="onEstadoInspeccionMousedown(linea, 'NO ACEPTADO', $event, () => actualizarLinea(grupo.id, index))"
											@click.native="onEstadoInspeccionClickSuprimir(linea, 'NO ACEPTADO', $event)"
											@mouseup.native="onEstadoInspeccionClickSuprimir(linea, 'NO ACEPTADO', $event)"
										>Rechazado</el-radio-button>
										<el-radio-button
											label="RC"
											@mousedown.native="onEstadoInspeccionMousedown(linea, 'RC', $event, () => actualizarLinea(grupo.id, index))"
											@click.native="onEstadoInspeccionClickSuprimir(linea, 'RC', $event)"
											@mouseup.native="onEstadoInspeccionClickSuprimir(linea, 'RC', $event)"
										>RC</el-radio-button>
									</el-radio-group>
									<el-button
										v-if="linea.tieneDocumento && linea.idLineaPropuesta"
										type="info"
										size="mini"
										icon="el-icon-camera-solid"
										@click="descargarDocumentoLinea(linea)"
									/>
								</div>
							</div>
						</template>
					</div>
				</template>

				<!-- Secciones y grupos para PUENTE -->
				<template v-else-if="propuesta.tipo === 'PUENTE'">
					<div 
						v-for="seccion in seccionesConLineas" 
						:key="seccion.id"
						class="seccion-section"
						:class="`seccion-${seccion.nombre.toLowerCase()}`"
					>
						<div 
							class="seccion-header"
							:class="[`seccion-${seccion.nombre.toLowerCase()}`]"
							@click="toggleSeccion(seccion.id)"
						>
							<i :class="seccion.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
							<span>{{ seccion.nombre }} ({{ contarLineasSeccion(seccion) }})</span>
						</div>
						<template v-if="seccion.visible">
							<div 
								v-for="grupo in seccion.grupos.filter(g => contarLineasGrupo(g) > 0)" 
								:key="grupo.id"
								class="grupo-section"
								:class="`grupo-${grupo.codigo.toLowerCase()}`"
							>
								<!-- Título del grupo -->
								<div 
									class="grupo-header" 
									@click="toggleGrupoPuente(seccion.id, grupo.id)"
									:class="{'grupo-collapsed': !grupo.visible}"
								>
									<i :class="grupo.visible ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
									<span class="grupo-nombre">{{ grupo.nombre }} ({{ contarLineasGrupo(grupo) }})</span>
								</div>
								<template v-if="grupo.visible">
									<div 
										v-for="(linea, index) in grupo.lineasVisibles" 
										:key="`${seccion.id}-${grupo.id}-${index}`"
										class="table-row con-estado"
									>
										<div class="col-posicion">{{ linea.posicion }}</div>
										<div class="col-referencia">
											<el-input
												v-model="linea.referencia"
												placeholder="Referencia"
												size="small"
												:disabled="true"
												readonly
											/>
										</div>
										<div class="col-equipo">
											<el-tooltip
												:content="tooltipEquipoContenido"
												placement="top"
												:disabled="!tooltipEquipoActivo"
											>
												<span
													class="celda-equipo-tooltip"
													@mouseenter="evaluarTooltipEquipoOverflow($event, getEquipoConTalla(linea))"
													@mouseleave="ocultarTooltipEquipo"
												>
													<el-input
														:value="getEquipoConTalla(linea)"
														placeholder="Equipo (Modelo, SN,_)"
														size="small"
														:disabled="true"
														readonly
													/>
												</span>
											</el-tooltip>
										</div>
										<div class="col-cantidad">
											<el-input
												v-model="linea.cantidad"
												placeholder="0"
												size="small"
												type="text"
												:disabled="true"
												readonly
												@keypress="soloNumerosYComa"
												@input="filtrarCantidad(linea)"
											/>
											<div
												v-if="getTextoConversionInformativa(linea)"
												class="conversion-info"
											>
												{{ getTextoConversionInformativa(linea) }}
											</div>
										</div>
										<div class="col-cantidad-aprobada">
											<el-input
												v-model="linea.cantidadAprobada"
												placeholder="Opcional"
												size="small"
												type="text"
												:class="{ 'cantidad-aprobada-invalida': isCantidadAprobadaInvalida(linea) }"
												@keypress="soloNumerosYComa"
												@input="filtrarCantidadAprobada(linea)"
												@blur="validarCantidadAprobadaEnLinea(linea)"
											/>
										</div>
										<div class="col-unidad">
											<el-input
												v-model="linea.unidad"
												placeholder="Unidad"
												size="small"
												:disabled="true"
												readonly
											/>
										</div>
										<div class="col-notas">
											<el-input
												v-model="linea.notas"
												placeholder="Notas"
												size="small"
												:disabled="true"
												readonly
											/>
										</div>
										<div class="col-anotaciones-tecnico">
											<el-input
												v-model="linea.anotacionesTecnico"
												:class="{ 'anotacion-tecnico-invalida': isAnotacionTecnicoInvalida(linea) }"
												type="textarea"
												:rows="2"
												:placeholder="getPlaceholderAnotacionesTecnico(linea)"
												size="small"
												@input="actualizarLineaPuente(seccion.id, grupo.id, index)"
											/>
										</div>
										<div class="col-estado">
											<el-radio-group v-model="linea.estado" size="small" @change="onEstadoInspeccionGroupChange(linea, $event, () => actualizarLineaPuente(seccion.id, grupo.id, index))">
												<el-radio-button
													label="ACEPTADO"
													@mousedown.native="onEstadoInspeccionMousedown(linea, 'ACEPTADO', $event, () => actualizarLineaPuente(seccion.id, grupo.id, index))"
													@click.native="onEstadoInspeccionClickSuprimir(linea, 'ACEPTADO', $event)"
													@mouseup.native="onEstadoInspeccionClickSuprimir(linea, 'ACEPTADO', $event)"
												>Aprobado</el-radio-button>
												<el-radio-button
													label="NO ACEPTADO"
													@mousedown.native="onEstadoInspeccionMousedown(linea, 'NO ACEPTADO', $event, () => actualizarLineaPuente(seccion.id, grupo.id, index))"
													@click.native="onEstadoInspeccionClickSuprimir(linea, 'NO ACEPTADO', $event)"
													@mouseup.native="onEstadoInspeccionClickSuprimir(linea, 'NO ACEPTADO', $event)"
												>Rechazado</el-radio-button>
												<el-radio-button
													label="RC"
													@mousedown.native="onEstadoInspeccionMousedown(linea, 'RC', $event, () => actualizarLineaPuente(seccion.id, grupo.id, index))"
													@click.native="onEstadoInspeccionClickSuprimir(linea, 'RC', $event)"
													@mouseup.native="onEstadoInspeccionClickSuprimir(linea, 'RC', $event)"
												>RC</el-radio-button>
											</el-radio-group>
											<el-button
												v-if="linea.tieneDocumento && linea.idLineaPropuesta"
												type="info"
												size="mini"
												icon="el-icon-camera-solid"
												@click="descargarDocumentoLinea(linea)"
											/>
										</div>
									</div>
								</template>
							</div>
						</template>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState } from 'vuex'
import { getUrl } from '@/helpers/api'

export default {
	name: 'GestionarPropuestas',
	data() {
		return {
			modalInicial: {
				visible: true
			},
			propuesta: {
				id: null,
				buqueId: null,
				buqueNombre: '',
				jMaquinas: '',
				fecha: '',
				numeroPropuesta: '',
				tipo: 'MAQUINAS',
				estado: null // Estado de la propuesta (2 o 3)
			},
			grupos: [],
			secciones: [],
			listaPropuestas: [],
			loadingPropuestas: false,
			propuestaSeleccionada: null,
			loadingInicial: true,
			estadoInspeccionSuprimirClick: null,
			tooltipEquipoActivo: false,
			tooltipEquipoContenido: ''
		}
	},
	computed: {
		...mapState({
			user: state => state.user.data
		}),
		perfilUsuario() {
			// Obtener el perfil del usuario desde el store
			return this.user ? this.user.perfil : null
		},
		gruposConLineas() {
			// Filtrar grupos que tengan al menos una línea
			return this.grupos.filter(grupo => this.contarLineasGrupo(grupo) > 0)
		},
		seccionesConLineas() {
			// Filtrar secciones que tengan al menos un grupo con líneas
			return this.secciones.filter(seccion => {
				return seccion.grupos.some(grupo => this.contarLineasGrupo(grupo) > 0)
			}).map(seccion => ({
				...seccion,
				grupos: seccion.grupos.filter(grupo => this.contarLineasGrupo(grupo) > 0)
			}))
		}
	},
	async created() {
		// Cargar lista de propuestas según el perfil del usuario
		await this.cargarPropuestas()
		this.loadingInicial = false
	},
	methods: {
		// Validar que solo se puedan escribir números (0-9) y coma para decimales
		soloNumerosYComa(event) {
			const char = String.fromCharCode(event.which)
			// Permitir números (0-9) y coma (,)
			if (!/[0-9,]/.test(char)) {
				event.preventDefault()
				return false
			}
			// Si es coma, verificar que no haya otra coma en el valor actual
			if (char === ',') {
				const input = event.target
				if (input.value && input.value.includes(',')) {
					event.preventDefault()
					return false
				}
			}
			return true
		},
		// Filtrar el valor para mantener solo números y una coma
		filtrarCantidad(linea) {
			if (linea.cantidad) {
				// Eliminar todo excepto números y coma
				let valor = String(linea.cantidad).replace(/[^0-9,]/g, '')
				// Asegurar que solo haya una coma
				const partes = valor.split(',')
				if (partes.length > 2) {
					valor = partes[0] + ',' + partes.slice(1).join('')
				}
				// Actualizar el valor
				this.$set(linea, 'cantidad', valor)
			}
		},
		parseCantidadDecimal(valor) {
			const txt = String(valor != null ? valor : '').trim()
			if (!txt) return null
			const num = parseFloat(txt.replace(',', '.'))
			return Number.isFinite(num) ? num : null
		},
		esCantidadAprobadaCompleta(valor) {
			const txt = String(valor != null ? valor : '').trim()
			if (!txt || txt.endsWith(',')) return false
			return this.parseCantidadDecimal(txt) !== null
		},
		esCantidadAprobadaCompletaInvalida(valor) {
			if (!this.esCantidadAprobadaCompleta(valor)) return false
			const num = this.parseCantidadDecimal(valor)
			return num !== null && num <= 0
		},
		isCantidadAprobadaInvalida(linea) {
			if (!linea) return false
			return this.esCantidadAprobadaCompletaInvalida(linea.cantidadAprobada)
		},
		validarCantidadAprobadaEnLinea(linea) {
			if (!linea || !this.esCantidadAprobadaCompletaInvalida(linea.cantidadAprobada)) return true
			this.$message.warning('La cantidad aprobada debe ser superior a 0')
			this.$set(linea, 'cantidadAprobada', '')
			return false
		},
		filtrarCantidadAprobada(linea) {
			if (linea.cantidadAprobada === null || linea.cantidadAprobada === undefined) return
			let valor = String(linea.cantidadAprobada).replace(/[^0-9,]/g, '')
			const partes = valor.split(',')
			if (partes.length > 2) {
				valor = partes[0] + ',' + partes.slice(1).join('')
			}
			if (this.esCantidadAprobadaCompletaInvalida(valor)) {
				this.$message.warning('La cantidad aprobada debe ser superior a 0')
				valor = ''
			}
			this.$set(linea, 'cantidadAprobada', valor)
		},
		normalizarEstadoInspeccion(lineaBackend) {
			const estadoInspeccion = (lineaBackend && lineaBackend.ESTADO_INSPECCION !== undefined && lineaBackend.ESTADO_INSPECCION !== null)
				? lineaBackend.ESTADO_INSPECCION
				: null
			const estadoLegacy = (lineaBackend && lineaBackend.estado !== undefined && lineaBackend.estado !== null)
				? lineaBackend.estado
				: null
			const raw = estadoInspeccion !== null ? estadoInspeccion : estadoLegacy
			const txt = (raw || '').toString().trim().toUpperCase()
			const num = Number(raw)
			if (txt === 'RC' || txt === 'REVISAR COMPRAS' || txt === 'REVISAR EN COMPRAS') return 'RC'
			if (txt === 'NO ACEPTADO' || txt === 'RECHAZADO' || txt === '3' || num === 3) return 'NO ACEPTADO'
			if (txt === 'ACEPTADO' || txt === 'APROBADO' || txt === '2' || num === 2) return 'ACEPTADO'
			return 'PENDIENTE'
		},
		getEquipoConTalla(linea) {
			if (!linea) return ''
			const eq = linea.equipo || ''
			const talla = linea.talla || linea.TALLA || ''
			if (!talla) return eq
			return `${eq} - ${talla}`
		},
		evaluarTooltipEquipoOverflow(event, texto) {
			const input = event.currentTarget ? event.currentTarget.querySelector('.el-input__inner') : null
			const txt = texto != null ? String(texto).trim() : ''
			if (!txt || !input) {
				this.ocultarTooltipEquipo()
				return
			}
			this.tooltipEquipoContenido = txt
			this.tooltipEquipoActivo = input.scrollWidth > input.clientWidth
		},
		ocultarTooltipEquipo() {
			this.tooltipEquipoActivo = false
			this.tooltipEquipoContenido = ''
		},
		getConversionSeleccionada(linea) {
			if (!linea || !Array.isArray(linea.articulo_conversion) || !linea.articulo_conversion.length) return null
			const unidadSel = (linea.unidad || '').toString().trim().toLowerCase()
			if (!unidadSel) return null
			const base = (linea.unidadBase || 'Uds').toString().trim().toLowerCase()
			if (unidadSel === base) return null
			return linea.articulo_conversion.find(c =>
				((c && c.CONVERSION) || '').toString().trim().toLowerCase() === unidadSel
			) || null
		},
		getTextoConversionInformativa(linea) {
			const conv = this.getConversionSeleccionada(linea)
			if (!conv) return ''
			const cantidad = Number((((linea && linea.cantidad) || '') + '').replace(',', '.'))
			const factor = Number((((conv && conv.CANTIDAD) || '') + '').replace(',', '.'))
			if (isNaN(cantidad) || isNaN(factor)) return ''
			const total = cantidad * factor
			const totalFmt = Number.isInteger(total) ? String(total) : total.toFixed(2).replace(/\.00$/, '')
			const base = (linea.unidadBase || 'Uds').toString().trim() || 'Uds'
			return `= ${totalFmt} ${base}`
		},
		async cargarPropuestas() {
			try {
				this.loadingPropuestas = true
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}

				// El backend filtrará solo propuestas con estado = 2 (inspectores)
				const response = await axios.post(
					`${endpoints.backend}entidad/propuestas_pedido/buscador/listarPropuestasGestionar`,
					{ estado: 2 }
				)

				if (Array.isArray(response.data)) {
					this.listaPropuestas = response.data
				} else if (response.data && Array.isArray(response.data.data)) {
					this.listaPropuestas = response.data.data
				} else {
					this.listaPropuestas = []
				}

				if (this.listaPropuestas.length === 0) {
					this.$message.info('No hay propuestas disponibles para gestionar')
				}
			} catch (error) {
				console.error('Error al cargar propuestas:', error)
				this.$message.error('Error al cargar las propuestas')
				this.listaPropuestas = []
			} finally {
				this.loadingPropuestas = false
			}
		},
		async cargarPropuestaSeleccionada(propuestaId) {
			try {
				this.loadingPropuestas = true
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}

				const response = await axios.post(
					`${endpoints.backend}entidad/propuestas_pedido/buscador/obtenerPropuesta`,
					{ id: propuestaId }
				)

				if (response.data && response.data.cabecera) {
					// Guardar el ID de la propuesta
					this.propuesta.id = response.data.id
					
					// Cargar datos de la cabecera
					this.propuesta.buqueId = response.data.cabecera.buqueId
					this.propuesta.buqueNombre = response.data.cabecera.buque
					this.propuesta.jMaquinas = response.data.cabecera.jefeMaquinas
					this.propuesta.fecha = response.data.cabecera.fecha
					this.propuesta.numeroPropuesta = response.data.cabecera.numeroPropuesta || response.data.codigo
					this.propuesta.tipo = response.data.cabecera.tipo || 'MAQUINAS'
					
					// El estado siempre será 2 para inspectores
					this.propuesta.estado = 2

					// Cargar grupos/secciones según el tipo PRIMERO
					await this.inicializarGrupos()

					// Esperar un momento para asegurar que los grupos estén inicializados
					await this.$nextTick()

					// Cargar líneas DESPUÉS de inicializar grupos
					if (response.data.lineas && Array.isArray(response.data.lineas)) {
						console.log('Líneas recibidas del backend:', response.data.lineas)
						this.cargarLineasDesdeBackend(response.data.lineas)
					} else {
						console.warn('No se recibieron líneas del backend o no es un array')
					}

					this.modalInicial.visible = false
					this.$message.success('Propuesta cargada correctamente')
				} else {
					this.$message.error('Error al cargar la propuesta')
				}
			} catch (error) {
				console.error('Error al cargar propuesta:', error)
				this.$message.error('Error al cargar la propuesta seleccionada')
			} finally {
				this.loadingPropuestas = false
			}
		},
		async inicializarGrupos() {
			try {
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}

				const response = await axios.post(
					`${endpoints.backend}entidad/propuestas_pedido/buscador/listarSecciones`,
					{ tipo: this.propuesta.tipo }
				)

				// La respuesta puede venir como array directo o dentro de { success: true, data: [...] }
				let data = response.data
				if (data && data.data && Array.isArray(data.data)) {
					data = data.data
				} else if (!Array.isArray(data)) {
					console.error('Formato de respuesta inesperado:', response.data)
					this.$message.error('Error en el formato de respuesta del backend')
					return
				}
				
				if (Array.isArray(data)) {
					if (this.propuesta.tipo === 'PUENTE') {
						this.inicializarGruposPuente(data)
					} else {
						this.inicializarGruposMaquinas(data)
					}
				}
			} catch (error) {
				console.error('Error al cargar grupos desde el backend:', error)
				this.$message.error('Error al cargar los grupos. Por favor, intente nuevamente.')
			}
		},
		inicializarGruposMaquinas(gruposBackend) {
			if (!gruposBackend || !Array.isArray(gruposBackend) || gruposBackend.length === 0) {
				console.warn('No se recibieron grupos desde el backend para MAQUINAS')
				return
			}

			console.log('Inicializando grupos MAQUINAS:', gruposBackend)
			this.grupos = gruposBackend.map((grupo) => {
				return {
					id: grupo.id,
					codigo: grupo.codigo,
					nombre: grupo.nombre,
					color: grupo.color,
					lineas: [],
					lineasVisibles: [],
					visible: false // Se expandirán solo los que tengan líneas
				}
			})
			console.log('Grupos inicializados:', this.grupos)
			this.secciones = []
		},
		inicializarGruposPuente(seccionesBackend) {
			if (!seccionesBackend || !Array.isArray(seccionesBackend) || seccionesBackend.length === 0) {
				console.warn('No se recibieron secciones desde el backend para PUENTE')
				return
			}

			this.secciones = seccionesBackend.map((seccion) => {
				return {
					id: seccion.id,
					nombre: seccion.nombre,
					color: seccion.color,
					grupos: seccion.grupos ? seccion.grupos.map((grupo) => ({
						id: grupo.id,
						codigo: grupo.codigo,
						nombre: grupo.nombre,
						color: grupo.color,
						lineas: [],
						lineasVisibles: [],
						visible: false // Se expandirán solo los que tengan líneas
					})) : [],
					visible: false // Se expandirán solo las que tengan líneas
				}
			})
			this.grupos = []
		},
		cargarLineasDesdeBackend(lineasBackend) {
			console.log('Cargando líneas desde backend:', lineasBackend)
			console.log('Grupos disponibles:', this.grupos)
			console.log('Tipo de propuesta:', this.propuesta.tipo)
			
			if (!lineasBackend || !Array.isArray(lineasBackend) || lineasBackend.length === 0) {
				console.warn('No hay líneas para cargar')
				return
			}
			
			// Conjuntos para rastrear qué grupos y secciones tienen datos
			const gruposConDatos = new Set()
			const seccionesConDatos = new Set()
			
			// Mapear las líneas del backend a la estructura de grupos
			lineasBackend.forEach(lineaBackend => {
				// Priorizar ESTADO_INSPECCION (nuevo campo de backend) para marcar radios.
				const estadoNormalizado = this.normalizarEstadoInspeccion(lineaBackend)
				
				console.log(`Procesando línea: grupo=${lineaBackend.grupo}, posicion=${lineaBackend.posicion}, estado=${estadoNormalizado}`)
				
				if (this.propuesta.tipo === 'PUENTE') {
					// Para PUENTE, buscar en secciones
					this.secciones.forEach(seccion => {
						seccion.grupos.forEach(grupo => {
							if (grupo.codigo === lineaBackend.grupo) {
								// Agregar línea al grupo
								const linea = {
									id: lineaBackend.id || null,
									idLineaPropuesta: lineaBackend.idLineaPropuesta || lineaBackend.id || null,
									posicion: lineaBackend.posicion,
									referencia: lineaBackend.referencia || '',
									equipo: lineaBackend.equipo || '',
									talla: lineaBackend.talla || lineaBackend.TALLA || '',
									cantidad: lineaBackend.cantidad || '',
									cantidadAprobada: lineaBackend.cantidadAprobada || lineaBackend.CANTIDAD_APROBADA || '',
									unidad: lineaBackend.unidad || '',
									unidadBase: lineaBackend.unidadBase || lineaBackend.UNIDAD_BASE || lineaBackend.UNIDAD || 'Uds',
									articulo_conversion: Array.isArray(lineaBackend.articulo_conversion) ? lineaBackend.articulo_conversion : (Array.isArray(lineaBackend.ARTICULO_CONVERSION) ? lineaBackend.ARTICULO_CONVERSION : []),
									notas: lineaBackend.notas || '',
									anotacionesTecnico: lineaBackend.anotacionesTecnico || lineaBackend.ANOTACIONES_TECNICO || '',
									estado: estadoNormalizado,
									tieneDocumento: !!(lineaBackend.tieneDocumento || lineaBackend.documentoAsociado || lineaBackend.tiene_documento)
								}
								grupo.lineas.push(linea)
								grupo.lineasVisibles.push(linea)
								gruposConDatos.add(`${seccion.id}-${grupo.id}`)
								seccionesConDatos.add(seccion.id)
							}
						})
					})
				} else {
					// Para MAQUINAS, buscar en grupos
					const grupo = this.grupos.find(g => g.codigo === lineaBackend.grupo)
					if (grupo) {
						const linea = {
							id: lineaBackend.id || null,
							idLineaPropuesta: lineaBackend.idLineaPropuesta || lineaBackend.id || null,
							posicion: lineaBackend.posicion,
							referencia: lineaBackend.referencia || '',
							equipo: lineaBackend.equipo || '',
							talla: lineaBackend.talla || lineaBackend.TALLA || '',
							cantidad: lineaBackend.cantidad || '',
							cantidadAprobada: lineaBackend.cantidadAprobada || lineaBackend.CANTIDAD_APROBADA || '',
							unidad: lineaBackend.unidad || '',
							unidadBase: lineaBackend.unidadBase || lineaBackend.UNIDAD_BASE || lineaBackend.UNIDAD || 'Uds',
							articulo_conversion: Array.isArray(lineaBackend.articulo_conversion) ? lineaBackend.articulo_conversion : (Array.isArray(lineaBackend.ARTICULO_CONVERSION) ? lineaBackend.ARTICULO_CONVERSION : []),
							notas: lineaBackend.notas || '',
							anotacionesTecnico: lineaBackend.anotacionesTecnico || lineaBackend.ANOTACIONES_TECNICO || '',
							estado: estadoNormalizado,
							tieneDocumento: !!(lineaBackend.tieneDocumento || lineaBackend.documentoAsociado || lineaBackend.tiene_documento)
						}
						grupo.lineas.push(linea)
						grupo.lineasVisibles.push(linea)
						gruposConDatos.add(grupo.id)
					}
				}
			})
			
			// Expandir solo grupos y secciones que tienen datos
			if (this.propuesta.tipo === 'PUENTE') {
				this.secciones.forEach(seccion => {
					if (seccionesConDatos.has(seccion.id)) {
						seccion.visible = true
					}
					seccion.grupos.forEach(grupo => {
						if (gruposConDatos.has(`${seccion.id}-${grupo.id}`)) {
							grupo.visible = true
						}
					})
				})
			} else {
				this.grupos.forEach(grupo => {
					if (gruposConDatos.has(grupo.id)) {
						grupo.visible = true
					}
				})
			}
		},
		toggleGrupo(grupoId) {
			const grupo = this.grupos.find(g => g.id === grupoId)
			if (grupo) {
				grupo.visible = !grupo.visible
			}
		},
		toggleGrupoPuente(seccionId, grupoId) {
			const seccion = this.secciones.find(s => s.id === seccionId)
			if (seccion) {
				const grupo = seccion.grupos.find(g => g.id === grupoId)
				if (grupo) {
					grupo.visible = !grupo.visible
				}
			}
		},
		toggleSeccion(seccionId) {
			const seccion = this.secciones.find(s => s.id === seccionId)
			if (seccion) {
				seccion.visible = !seccion.visible
			}
		},
		contarLineasGrupo(grupo) {
			return grupo.lineasVisibles ? grupo.lineasVisibles.length : 0
		},
		contarLineasSeccion(seccion) {
			let total = 0
			seccion.grupos.forEach(grupo => {
				total += this.contarLineasGrupo(grupo)
			})
			return total
		},
		actualizarLinea(grupoId, index) {
			// Sincronizar con el array completo de líneas
			const grupo = this.grupos.find(g => g.id === grupoId)
			if (grupo && grupo.lineasVisibles[index]) {
				const lineaVisible = grupo.lineasVisibles[index]
				const indiceEnLineas = grupo.lineas.findIndex(l => l.posicion === lineaVisible.posicion)
				if (indiceEnLineas !== -1) {
					grupo.lineas[indiceEnLineas] = { ...lineaVisible }
				}
			}
		},
		actualizarLineaPuente(seccionId, grupoId, index) {
			const seccion = this.secciones.find(s => s.id === seccionId)
			if (seccion) {
				const grupo = seccion.grupos.find(g => g.id === grupoId)
				if (grupo && grupo.lineasVisibles[index]) {
					const lineaVisible = grupo.lineasVisibles[index]
					const indiceEnLineas = grupo.lineas.findIndex(l => l.posicion === lineaVisible.posicion)
					if (indiceEnLineas !== -1) {
						grupo.lineas[indiceEnLineas] = { ...lineaVisible }
					}
				}
			}
		},
		normalizarEstadoInspeccionUI(estado) {
			const txt = String(estado || '').trim().toUpperCase()
			if (txt === 'RC' || txt === 'REVISAR COMPRAS' || txt === 'REVISAR EN COMPRAS') return 'RC'
			if (txt === 'NO ACEPTADO' || txt === 'RECHAZADO') return 'NO ACEPTADO'
			if (txt === 'ACEPTADO' || txt === 'APROBADO') return 'ACEPTADO'
			return 'PENDIENTE'
		},
		onEstadoInspeccionMousedown(linea, label, event, syncFn) {
			if (!linea || !event) return
			const actual = this.normalizarEstadoInspeccionUI(linea.estado)
			const target = this.normalizarEstadoInspeccionUI(label)
			if (actual !== target) return

			event.preventDefault()
			event.stopPropagation()
			this.estadoInspeccionSuprimirClick = { linea, label: target }
			linea.estado = 'PENDIENTE'
			if (typeof syncFn === 'function') syncFn()
		},
		onEstadoInspeccionClickSuprimir(linea, label, event) {
			const bloqueo = this.estadoInspeccionSuprimirClick
			if (!bloqueo || !linea || !event) return

			const target = this.normalizarEstadoInspeccionUI(label)
			if (bloqueo.linea !== linea || bloqueo.label !== target) return

			event.preventDefault()
			event.stopPropagation()
			linea.estado = 'PENDIENTE'
		},
		onEstadoInspeccionGroupChange(linea, nuevoEstado, syncFn) {
			const bloqueo = this.estadoInspeccionSuprimirClick
			if (bloqueo && bloqueo.linea === linea) {
				const target = bloqueo.label
				this.estadoInspeccionSuprimirClick = null
				if (this.normalizarEstadoInspeccionUI(nuevoEstado) === target) {
					this.$nextTick(() => {
						linea.estado = 'PENDIENTE'
					})
					return
				}
			}
			if (typeof syncFn === 'function') syncFn()
		},
		estadoRequiereAnotacionTecnico(estado) {
			const estadoNorm = String(estado || '').trim().toUpperCase()
			return estadoNorm === 'NO ACEPTADO' || estadoNorm === 'RC'
		},
		getPlaceholderAnotacionesTecnico(linea) {
			if (linea && this.estadoRequiereAnotacionTecnico(linea.estado)) {
				return 'Motivo rechazo'
			}
			return 'Observaciones del dpto. técnico'
		},
		isAnotacionTecnicoInvalida(linea) {
			if (!linea) return false
			if (!this.estadoRequiereAnotacionTecnico(linea.estado)) return false
			return !String(linea.anotacionesTecnico || '').trim()
		},
		validarAnotacionesTecnicoObligatorias() {
			const invalidas = []

			if (this.propuesta.tipo === 'PUENTE') {
				this.secciones.forEach(seccion => {
					seccion.grupos.forEach(grupo => {
						grupo.lineasVisibles.forEach(linea => {
							if (this.isAnotacionTecnicoInvalida(linea)) {
								invalidas.push({
									seccion: seccion.nombre,
									grupo: grupo.codigo,
									posicion: linea.posicion
								})
							}
						})
					})
				})
			} else {
				this.grupos.forEach(grupo => {
					grupo.lineasVisibles.forEach(linea => {
						if (this.isAnotacionTecnicoInvalida(linea)) {
							invalidas.push({
								grupo: grupo.codigo,
								posicion: linea.posicion
							})
						}
					})
				})
			}

			if (!invalidas.length) return true

			const posiciones = invalidas.slice(0, 8).map(i => i.posicion).join(', ')
			const sufijo = invalidas.length > 8 ? `… (+${invalidas.length - 8})` : ''
			this.$message.error(`Para líneas en "Rechazado" o "RC" es obligatorio indicar Anotaciones Dpt. Técnico. Posiciones: ${posiciones}${sufijo}`)
			return false
		},
		validarCantidadesAprobadas() {
			const invalidas = []

			const revisarLinea = (linea, meta) => {
				if (this.esCantidadAprobadaCompletaInvalida(linea.cantidadAprobada)) {
					invalidas.push({ posicion: linea.posicion, ...meta })
				}
			}

			if (this.propuesta.tipo === 'PUENTE') {
				this.secciones.forEach(seccion => {
					seccion.grupos.forEach(grupo => {
						grupo.lineasVisibles.forEach(linea => {
							revisarLinea(linea, { seccion: seccion.nombre, grupo: grupo.codigo })
						})
					})
				})
			} else {
				this.grupos.forEach(grupo => {
					grupo.lineasVisibles.forEach(linea => {
						revisarLinea(linea, { grupo: grupo.codigo })
					})
				})
			}

			if (!invalidas.length) return true

			const posiciones = invalidas.slice(0, 8).map(i => i.posicion).join(', ')
			const sufijo = invalidas.length > 8 ? `… (+${invalidas.length - 8})` : ''
			this.$message.error(`La cantidad aprobada debe ser superior a 0. Posiciones: ${posiciones}${sufijo}`)
			return false
		},
		async guardarPropuesta() {
			try {
				if (!this.validarAnotacionesTecnicoObligatorias()) return
				if (!this.validarCantidadesAprobadas()) return
				// Recopilar todas las líneas con sus estados actualizados
				const lineas = []
				
				if (this.propuesta.tipo === 'PUENTE') {
					this.secciones.forEach(seccion => {
						seccion.grupos.forEach(grupo => {
							grupo.lineasVisibles.forEach(linea => {
								lineas.push({
									id: linea.id || null,
									grupo: grupo.codigo,
									grupoNombre: grupo.nombre,
									seccion: seccion.nombre,
									posicion: linea.posicion,
									referencia: linea.referencia || '',
									equipo: linea.equipo || '',
									talla: linea.talla || linea.TALLA || '',
									cantidad: linea.cantidad || 0,
									cantidadAprobada: linea.cantidadAprobada || null,
									unidad: linea.unidad || '',
									notas: linea.notas || '',
									anotacionesTecnico: linea.anotacionesTecnico || '',
									estado: linea.estado || 'PENDIENTE'
								})
							})
						})
					})
				} else {
					this.grupos.forEach(grupo => {
						grupo.lineasVisibles.forEach(linea => {
							lineas.push({
								id: linea.id || null,
								grupo: grupo.codigo,
								grupoNombre: grupo.nombre,
								posicion: linea.posicion,
								referencia: linea.referencia || '',
								equipo: linea.equipo || '',
								talla: linea.talla || linea.TALLA || '',
								cantidad: linea.cantidad || 0,
								cantidadAprobada: linea.cantidadAprobada || null,
								unidad: linea.unidad || '',
								notas: linea.notas || '',
								anotacionesTecnico: linea.anotacionesTecnico || '',
								estado: linea.estado || 'PENDIENTE'
							})
						})
					})
				}

				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}

				// Llamar al backend para guardar los estados de las líneas
				const response = await axios.post(
					`${endpoints.backend}entidad/propuestas_pedido/buscador/guardarGestionPropuesta`,
					{
						id: this.propuesta.id,
						lineas: lineas
					}
				)

				if (response.data && !response.data.error) {
					this.$message.success('Propuesta guardada correctamente')
				} else {
					const mensaje = (response.data && response.data.mensaje) ? response.data.mensaje : 'Error al guardar la propuesta'
					this.$message.error(mensaje)
				}
			} catch (error) {
				console.error('Error al guardar propuesta:', error)
				this.$message.error('Error al guardar la propuesta. Por favor, intente nuevamente.')
			}
		},
		async lanzarPropuesta() {
			try {
				await this.$confirm('¿Estás seguro de terminar la revisión de la propuesta? Se aprobarán todas las líneas sin marcar', 'Confirmar', {
					confirmButtonText: 'Sí',
					cancelButtonText: 'No',
					type: 'warning'
				})

				// Después de confirmar: las líneas sin marcar se dan por aprobadas
				if (this.propuesta.tipo === 'PUENTE') {
					this.secciones.forEach(seccion => {
						seccion.grupos.forEach(grupo => {
							grupo.lineasVisibles.forEach(linea => {
								if (!linea.estado || linea.estado === 'PENDIENTE') {
									linea.estado = 'ACEPTADO'
								}
							})
						})
					})
				} else {
					this.grupos.forEach(grupo => {
						grupo.lineasVisibles.forEach(linea => {
							if (!linea.estado || linea.estado === 'PENDIENTE') {
								linea.estado = 'ACEPTADO'
							}
						})
					})
				}

				if (!this.validarAnotacionesTecnicoObligatorias()) return

				// Guardar los cambios (incluidas las líneas recién aprobadas)
				await this.guardarPropuesta()

				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}

				// Llamar al backend para cambiar el estado de 2 (inspector) a 3 (compras)
				const response = await axios.post(
					`${endpoints.backend}entidad/propuestas_pedido/buscador/cerrarGestionarPropuesta`,
					{
						id: this.propuesta.id,
						codigo: this.propuesta.numeroPropuesta,
						estado: 3
					}
				)

				if (response.data && !response.data.error) {
					this.$message.success('Propuesta lanzada correctamente')
					// Cerrar ventana y recargar
					this.cerrarVentana()
					setTimeout(() => {
						window.location.reload()
					}, 1000)
				} else {
					const mensaje = (response.data && response.data.mensaje) ? response.data.mensaje : 'Error al terminar revision de la propuesta'
					this.$message.error(mensaje)
				}
			} catch (error) {
				if (error !== 'cancel') {
					console.error('Error al terminar revision de propuesta:', error)
					this.$message.error('Error al terminar revision de la propuesta. Por favor, intente nuevamente.')
				}
			}
		},
		cerrarVentana() {
			// Cerrar solo la ventana sin lanzar la propuesta
			if (window.parent && window.parent !== window) {
				if (window.parent.Vue && window.parent.Vue.prototype) {
					window.parent.Vue.prototype.$root.$emit('cerrar-ventana-propuesta')
				} else {
					window.parent.postMessage({ type: 'cerrar-ventana-propuesta' }, '*')
				}
			} else {
				this.$root.$emit('cerrar-ventana-propuesta')
			}
		},
		async descargarDocumentoLinea(linea) {
			const idLinea = linea.idLineaPropuesta || linea.id
			if (!idLinea) {
				this.$message.warning('No hay documento para descargar')
				return
			}
			try {
				const endpoints = getUrl()
				if (!endpoints) {
					this.$message.error('Error de configuración')
					return
				}
				const url = `${endpoints.backend}entidad/lineas_propuesta_pedido/${idLinea}/descargarDocumento`
				const response = await axios.post(url, null, { responseType: 'blob' })
				const blob = response.data
				if (!(blob instanceof Blob)) {
					this.$message.error('La respuesta no es un archivo válido')
					return
				}
				const contentType = response.headers['content-type'] || ''
				if (contentType.indexOf('application/json') !== -1) {
					this.$message.error('No se pudo descargar el documento')
					return
				}
				const contentDisposition = response.headers['content-disposition']
				let nombre = 'documento-linea'
				if (contentDisposition) {
					const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
					if (match && match[1]) nombre = match[1].replace(/['"]/g, '').trim()
				}
				const link = document.createElement('a')
				link.href = window.URL.createObjectURL(blob)
				link.download = nombre
				link.click()
				window.URL.revokeObjectURL(link.href)
				this.$message.success('Descarga iniciada')
			} catch (error) {
				console.error('Error al descargar documento:', error)
				this.$message.error(error.response && error.response.status === 404 ? 'Documento no encontrado' : 'Error al descargar el documento')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.gestionar-propuestas-page {
	height: 100vh;
	overflow: auto;
	background-color: $--color-background;
}

.propuesta-container {
	padding: 20px;
}

.propuesta-header {
	background-color: white;
	padding: 15px;
	border-radius: 4px;
	margin-bottom: 20px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);

	.header-row {
		display: grid;
		grid-template-columns: 1fr 1fr 2fr 1fr 1fr;
		gap: 15px;
		margin-bottom: 15px;
		align-items: center;
	}

	.header-field {
		label {
			display: block;
			font-weight: bold;
			margin-bottom: 5px;
			font-size: 0.9rem;
		}

		&.header-title {
			text-align: center;
			h2 {
				margin: 0;
				font-size: 1.2rem;
				color: $--color-primary;
			}
		}
	}

	.propuesta-actions {
		display: flex;
		justify-content: flex-end;
		gap: 10px;
		padding-top: 10px;
		border-top: 1px solid #eee;
	}
}

.propuesta-table-container {
	background-color: white;
	border-radius: 4px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
	overflow: hidden;
}

.table-header {
	display: grid;
	grid-template-columns: 80px 200px 1fr 100px 120px 1fr;
	background-color: $--color-main-header;
	color: white;
	font-weight: bold;
	font-size: 0.85rem;
	padding: 0.5rem;
	border-bottom: 2px solid $--color-main-header;

	> div {
		padding: 0.25rem;
		display: flex;
		align-items: center;
	}

	&.con-estado {
		grid-template-columns: 80px 200px 1fr 100px 120px 110px minmax(100px, 0.35fr) 300px 300px;
	}
}

.grupo-section {
	.table-row {
		display: grid;
		grid-template-columns: 80px 200px 1fr 100px 120px 1fr;
		border-bottom: 1px solid #c0c4cc;
		transition: background-color 0.2s;

		&:hover {
			background-color: rgba($--color-header, 0.05);
		}

		&.con-estado {
			grid-template-columns: 80px 200px 1fr 100px 120px 110px minmax(100px, 0.35fr) 300px 300px;
		}

		> div {
			padding: 0.5rem;
			display: flex;
			align-items: center;
			border-right: 1px solid #c0c4cc;

			&:last-child {
				border-right: none;
			}
		}

		.col-posicion {
			justify-content: center;
		}

		.col-referencia,
		.col-equipo {
			min-width: 0;

			::v-deep .el-input__inner {
				padding-left: 8px;
				padding-right: 8px;
			}
		}

		.celda-equipo-tooltip {
			display: block;
			width: 100%;
			min-width: 0;

			::v-deep .el-input__inner {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}

		// Estilos para los inputs dentro de las filas
		::v-deep .el-input {
			.el-input__inner {
				border-color: #c0c4cc;
				border-width: 1px;
				
				&:hover {
					border-color: #a0a4a8;
				}

				&:focus {
					border-color: $--color-primary;
				}

				&::placeholder {
					color: #909399;
					opacity: 1;
				}
			}
		}

		.col-cantidad {
			flex-direction: column;
			align-items: stretch;
			justify-content: center;

			::v-deep .el-input__inner {
				text-align: right;
				border-color: #c0c4cc;
				
				&:hover {
					border-color: #a0a4a8;
				}

				&:focus {
					border-color: $--color-primary;
				}

				&::placeholder {
					color: #909399;
					opacity: 1;
				}
			}

			.conversion-info {
				margin-top: 4px;
				font-size: 12px;
				color: #606266;
				text-align: right;
				white-space: nowrap;
			}
		}
		.col-cantidad-aprobada {
			::v-deep .el-input__inner {
				text-align: right;
			}

			::v-deep .cantidad-aprobada-invalida .el-input__inner {
				border-color: #f56c6c !important;
			}

			::v-deep .cantidad-aprobada-invalida .el-input__inner:focus {
				border-color: #f56c6c !important;
				box-shadow: 0 0 0 1px rgba(245, 108, 108, 0.2);
			}
		}
		.col-anotaciones-tecnico {
			align-items: stretch;

			::v-deep .anotacion-tecnico-invalida .el-textarea__inner {
				border-color: #f56c6c !important;
			}

			::v-deep .anotacion-tecnico-invalida .el-textarea__inner:focus {
				border-color: #f56c6c !important;
				box-shadow: 0 0 0 1px rgba(245, 108, 108, 0.2);
			}
		}
	}
}

.grupo-section {
	border: 2px solid transparent;

	.grupo-header {
		color: #000;
		font-weight: bold;
		padding: 0.75rem 1rem;
		border-bottom: 1px solid #dcdfe6;
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		transition: all 0.2s;
		font-size: 0.9rem;
		position: relative;

		&:hover {
			opacity: 0.85;
		}

		&.grupo-collapsed {
			opacity: 0.9;
		}

		i {
			font-size: 0.9rem;
			color: #000;
			font-weight: bold;
		}

		.grupo-nombre {
			font-weight: bold;
		}
	}
}

.seccion-section {
	margin-bottom: 1rem;

	.seccion-header {
		color: white;
		font-weight: bold;
		padding: 1rem;
		border-bottom: 2px solid rgba(0, 0, 0, 0.2);
		cursor: pointer;
		display: flex;
		align-items: center;
		gap: 0.5rem;
		transition: all 0.2s;
		font-size: 1.1rem;

		&:hover {
			opacity: 0.9;
		}

		&.seccion-collapsed {
			opacity: 0.8;
		}

		i {
			font-size: 1rem;
			color: white;
			font-weight: bold;
		}

		.seccion-nombre {
			font-weight: bold;
		}
	}
}

// Colores de secciones PUENTE
// Bordes según la sección padre para PUENTE
.seccion-cubierta .grupo-section {
	border-color: #f44336; // Rojo para CUBIERTA
}

.seccion-fonda .grupo-section {
	border-color: #4caf50; // Verde para FONDA
}

.seccion-puente .grupo-section {
	border-color: #2196f3; // Azul para PUENTE
}

// Estilos para columna de estado
.col-estado {
	width: 100%;
	box-sizing: border-box;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: stretch;
	justify-content: flex-start;
	gap: 8px;
	min-width: 0;

	.el-radio-group {
		display: flex;
		flex-wrap: nowrap;
		align-items: stretch;
		flex: 1 1 0;
		min-width: 0;
		gap: 0;
	}

	.el-radio-button {
		flex: 1 1 0;
		min-width: 0;

		::v-deep .el-radio-button__inner {
			width: 100%;
			padding: 8px 8px;
			box-sizing: border-box;
		}
	}

	> .el-button {
		flex-shrink: 0;
		align-self: center;
	}
}

// Colores de fondo por grupo (MAQUINAS)
.grupo-ag { 
	.grupo-header { background-color: #b3d9ff; }
	.table-row { background-color: rgba(179, 217, 255, 0.2); } 
}
.grupo-bm { 
	.grupo-header { background-color: #c8e6c9; }
	.table-row { background-color: rgba(200, 230, 201, 0.2); } 
}
.grupo-cf { 
	.grupo-header { background-color: #ffe0b2; }
	.table-row { background-color: rgba(255, 224, 178, 0.2); } 
}
.grupo-ca { 
	.grupo-header { background-color: #f8bbd0; }
	.table-row { background-color: rgba(248, 187, 208, 0.2); } 
}
.grupo-dp { 
	.grupo-header { background-color: #b2dfdb; }
	.table-row { background-color: rgba(178, 223, 219, 0.2); } 
}
.grupo-el { 
	.grupo-header { background-color: #fff9c4; }
	.table-row { background-color: rgba(255, 249, 196, 0.2); } 
}
.grupo-fl { 
	.grupo-header { background-color: #e1bee7; }
	.table-row { background-color: rgba(225, 190, 231, 0.2); } 
}
.grupo-fr { 
	.grupo-header { background-color: #b3e5fc; }
	.table-row { background-color: rgba(179, 229, 252, 0.2); } 
}
.grupo-ga { 
	.grupo-header { background-color: #c5cae9; }
	.table-row { background-color: rgba(197, 202, 233, 0.2); } 
}
.grupo-ep { 
	.grupo-header { background-color: #ffe082; }
	.table-row { background-color: rgba(255, 224, 130, 0.2); } 
}
.grupo-he { 
	.grupo-header { background-color: #dcedc8; }
	.table-row { background-color: rgba(220, 237, 200, 0.2); } 
}
.grupo-hi { 
	.grupo-header { background-color: #d1c4e9; }
	.table-row { background-color: rgba(209, 196, 233, 0.2); } 
}
.grupo-hd { 
	.grupo-header { background-color: #b2ebf2; }
	.table-row { background-color: rgba(178, 235, 242, 0.2); } 
}
.grupo-mt { 
	.grupo-header { background-color: #e0e0e0; }
	.table-row { background-color: rgba(224, 224, 224, 0.3); } 
}
.grupo-mo { 
	.grupo-header { background-color: #cfd8dc; }
	.table-row { background-color: rgba(207, 216, 220, 0.2); } 
}
.grupo-mp { 
	.grupo-header { background-color: #c8e6c9; }
	.table-row { background-color: rgba(200, 230, 201, 0.2); } 
}
.grupo-pr { 
	.grupo-header { background-color: #ffe0b2; }
	.table-row { background-color: rgba(255, 224, 178, 0.2); } 
}
.grupo-ne { 
	.grupo-header { background-color: #f8bbd0; }
	.table-row { background-color: rgba(248, 187, 208, 0.2); } 
}
.grupo-pp { 
	.grupo-header { background-color: #b2dfdb; }
	.table-row { background-color: rgba(178, 223, 219, 0.2); } 
}
.grupo-pi { 
	.grupo-header { background-color: #fff9c4; }
	.table-row { background-color: rgba(255, 249, 196, 0.2); } 
}
.grupo-pc { 
	.grupo-header { background-color: #e1bee7; }
	.table-row { background-color: rgba(225, 190, 231, 0.2); } 
}
.grupo-qu { 
	.grupo-header { background-color: #b3e5fc; }
	.table-row { background-color: rgba(179, 229, 252, 0.2); } 
}
.grupo-ss { 
	.grupo-header { background-color: #c5cae9; }
	.table-row { background-color: rgba(197, 202, 233, 0.2); } 
}
.grupo-si { 
	.grupo-header { background-color: #ffe082; }
	.table-row { background-color: rgba(255, 224, 130, 0.2); } 
}
.grupo-sb { 
	.grupo-header { background-color: #dcedc8; }
	.table-row { background-color: rgba(220, 237, 200, 0.2); } 
}
.grupo-tr { 
	.grupo-header { background-color: #d1c4e9; }
	.table-row { background-color: rgba(209, 196, 233, 0.2); } 
}
.grupo-va { 
	.grupo-header { background-color: #b2ebf2; }
	.table-row { background-color: rgba(178, 235, 242, 0.2); } 
}
.grupo-vr { 
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); } 
}

// Colores de fondo por grupo para PUENTE - Sección CUBIERTA
.grupo-cj { 
	.grupo-header { background-color: #ebeef1; }
	.table-row { background-color: rgba(235, 238, 241, 0.3); } 
}
.grupo-ch { 
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); } 
}
.grupo-hf { 
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); } 
}
.grupo-jp { 
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); } 
}
.grupo-ql { 
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); } 
}

// Colores de fondo por grupo para PUENTE - Sección FONDA
.grupo-li { 
	.grupo-header { background-color: #d9e1f2; }
	.table-row { background-color: rgba(217, 225, 242, 0.2); } 
}
.grupo-me { 
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); } 
}

// Colores de fondo por grupo para PUENTE - Sección PUENTE
.grupo-ll { 
	.grupo-header { background-color: #e2efda; }
	.table-row { background-color: rgba(226, 239, 218, 0.2); } 
}
.grupo-se { 
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); } 
}

// Estilos específicos para VARIOS en sección PUENTE
.seccion-puente .grupo-vr {
	.grupo-header { background-color: #ebeef1; }
	.table-row { background-color: rgba(235, 238, 241, 0.3); } 
}

// Estilos específicos para VARIOS en sección FONDA
.seccion-fonda .grupo-vr {
	.grupo-header { background-color: #fce4d6; }
	.table-row { background-color: rgba(252, 228, 214, 0.2); } 
}

// Colores específicos por sección según la imagen
.seccion-cubierta {
	.seccion-header {
		background-color: #f44336; // Rojo para CUBIERTA
		border-bottom-color: #d32f2f;
	}
}

.seccion-fonda {
	.seccion-header {
		background-color: #4caf50; // Verde para FONDA
		border-bottom-color: #388e3c;
	}
}

.seccion-puente {
	.seccion-header {
		background-color: #2196f3; // Azul para PUENTE
		border-bottom-color: #1976d2;
	}
}

@media (max-width: 768px) {
	.propuesta-header .header-row {
		grid-template-columns: 1fr;
	}

	.table-header,
	.table-row {
		grid-template-columns: 60px 1fr 1.5fr 80px 90px 90px minmax(70px, 0.45fr) 250px 209px;
		font-size: 0.85rem;

		&.con-estado {
			grid-template-columns: 60px 1fr 1.5fr 80px 90px 90px minmax(70px, 0.45fr) 250px 209px;
		}
	}
}

// Campos no editables: texto legible (Element UI usa #c0c4cc en .is-disabled)
.gestionar-propuestas-page ::v-deep .el-input.is-disabled .el-input__inner,
.gestionar-propuestas-page ::v-deep .el-textarea.is-disabled .el-textarea__inner,
.gestionar-propuestas-page ::v-deep .el-input-number.is-disabled .el-input__inner {
	color: #606266;
}
</style>
